<template>
  <ms-popover
    v-model:visible="visiblePopover"
    placement="bottom"
    :width="popoverWidth"
    :offset="18"
    @show="onShowPopover"
    @hide="onHidePopover"
  >
    <template #reference>
      <slot name="reference" />
    </template>
    <notify-list
      ref="listNotify"
      :auto-load-data="false"
      @onClickNotifyItem="onClickNotifyItem"
    />
  </ms-popover>
</template>

<script>
import MsPopover from '@/components/popover'
import { mapActions, mapMutations, mapState } from 'vuex'
import NotifyList from './notify-list'
import BaseList from '@/views/base/base-list'
import { getEnvConfig } from '@/utils/env-variables'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { UserType } from '@/common/constant'
import { getUserType } from '@/utils/auth'

const platformNotifyPopup = () => require('@/views/pages/common/notify/platform-notify-popup.vue')

export default {
  extends: BaseList,
  emits: ['ringBell'],

  components: {
    MsPopover,
    NotifyList
  },

  data () {
    return {
      visiblePopover: false,
      popoverWidth: 422,
      ISMACParam: {}
    }
  },

  watch: {
    numberNotifyUnPreview (newVal, oldVal) {
      if (newVal > oldVal) {
        this.$emit('ringBell')
      }
    }
  },

  computed: {
    ...mapState('notify', {
      numberNotifyUnPreview: 'numberNotifyUnPreview'
    })
  },

  methods: {
    ...mapActions('notify', [
      'getNotify',
      'countNotifyUnPreview',
      'previewNotify'
    ]),
    ...mapMutations('notify', ['setNumberNotifyUnPreview']),

    /**
     * @author PVThang
     * @description Xử lý khi show popover
     */
    async onShowPopover () {
      const me = this

      await me.$refs.listNotify?.initData()
      if (me.numberNotifyUnPreview > 0) {
        me.previewNotify()
      }
    },

    /**
     * @author PVThang
     * @description Xử lý khi hide popover
     */
    onHidePopover () {
      const me = this

      // if (me.numberNotifyUnPreview > 0) {
      //   me.previewNotify()
      // }
      me.setNumberNotifyUnPreview(0)
    },

    /**
     * @author PVThang
     * @description đóng popover thông báo
     */
    closePopover () {
      this.visiblePopover = false
    },

    /**
     * @author PVThang
     * @description xử lý khi click vào 1 thông báo
     */
    onClickNotifyItem () {
      this.closePopover()
    },

    /**
     * @description Lấy UI popup
     * @author lhlong
     */
    async getOtherPopup () {
      return await platformNotifyPopup()
    },

    getISMACNotiParam () {
      const userType = getUserType()
      const ISMACConfig = getEnvConfig('ISMACConfig') || {}
      let appId = ''
      let userPostFix = ''

      switch (userType) {
        case UserType.Teacher:
          userPostFix = getContextData(ContextDataKey.PhoneNumber)
          appId = ISMACConfig.isInfo.teacher
          break
        case UserType.Student:
          userPostFix = getContextData(ContextDataKey.UserName)
          appId = ISMACConfig.isInfo.student
      }

      this.ISMACData.appId = appId
      this.ISMACData.uuId = `${appId}_${userPostFix}`
    }
  },

  async created () {
    await this.countNotifyUnPreview(this.ISMACData).then((res) => {
      if (res?.Data?.Notify) {
        const formParams = {
          notify: res.Data.Notify,
          time: res.ServerDate
        }
        this.showDetail('', formParams)
      }
    })
  }
}
</script>

<style lang="scss" scoped></style>
